export const WORKOUT_REQUEST_GET_OPTIONS = [
  "id",
  "facility.name",
  "facility.code",
  "facility.backgroundColor",
  "facility.foregroundColor",
  "facility.strokeColor",
  "facility.shutOffPeriodInHours",
  "facility.shutOffHours",
  "facility.timezone",
  "date",
  "status",
  "hasComment",
  "hasRacingSecretaryComment"
];
